import {
    CardContent, CardHeader, Grid, FormControl,
    TextField, Button, Collapse, InputAdornment,
    Alert, Box, Card, IconButton
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import jwt_decode from "jwt-decode";
import ProyectosPlanLista from './ProyectosPlanLista';
import ProyectoPlanForma from './plan/ProyectoPlanForma';
import { NumberFormatMoney, useForm } from './useForm';
import { useParams } from 'react-router-dom'
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';

export default function PlanForma() {
    const params = useParams()
    const planeacion = params.planeacion;
    const [editing, setEditing] = useState(false)
    const [isEditing, setIsEditing] = useState(false)
    const [montoExcedido, setMontoExcedido] = useState(false);
    const [planPresupuestal, setPlanPresupuestal] = useState({})
    const [severity, setSeverity] = useState('error')
    const token = sessionStorage.getItem('token')
    const porcentajePrioridad1 = Number(Number(1) - Number(process.env.REACT_APP_PRIORIDAD_DOS)).toFixed(2)
    const porcentajePrioridad2 = Number(process.env.REACT_APP_PRIORIDAD_DOS)
    const decoded = jwt_decode(token);
    let isCoordinacion = Boolean(false);
    //console.log(`decodificado en forma ${JSON.stringify(decoded)}`)

    const idResponsable = decoded.id;

    const cargarPlan = async () => {

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/byUser/${idResponsable}/${planeacion}/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        }

        )

        if (res.status === 404) {
            setPlanPresupuestal({ idPlanPresupuestal: 0, montoMaximo: 0 })
            setEditing(false)
            //console.log('regresó 404')
            return { idPlanPresupuestal: 0, montoMaximo: 0 }
        }


        else {
            //console.log('la planeación si existe')

            const data = await res.json()
            //console.log(data)
            setPlanPresupuestal(data)
            setFase(data.fase)
            setEditing(true) //Estado

            return data
        }


    }

    const [loading, setLoading] = useState(false)

    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [fase, setFase] = useState(0)
    const obtenerReglas = () => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }
    const verificarTipoProyectosPerfilSinProyecto = () => {
        let reglas = decoded.rules
        if (!reglas)
            reglas = obtenerReglas()
        //console.log(`REGLAS EN PLANFORMA: ${JSON.stringify(reglas)}`)
        /*Si tiene permiso para manejar proyectos de investigación
          el tipo por default en la forma será ese, de lo contrario
          será gestion*/
        if (!isEditing) {
            if (reglas) {
                for (let i = 0; i < reglas.length; i++) {
                    if (reglas[i].action === 'coordinacion' && reglas[i].subject === 'coordinacion') {
                        isCoordinacion = Boolean(true)
                    }
                    if (reglas[i].action === 'manage' && reglas[i].subject === 'proyectoInvestigacion') {
                        //console.log('TIENE PERMISOS PARA PROYECTO DE INVESTIGACIÓN')
                        return true
                    }

                }
            }
            else{
                setSeverity('warning')
                setMensaje('Por favor cierre su sesión (botón LOGOUT) y vuelva a entrar')
            }
            //console.log('NO TIENE PERMISOS PARA PROYECTO DE INVESTIGACIÓN')
            return false
        }
    }
    const datosIniciales = {
        idPlan: planPresupuestal.id,
        tipo: verificarTipoProyectosPerfilSinProyecto() ? 'investigacion' : 'gestion', //verificar después como hacerlo con casl
        clave: '',
        descripcion: '',
        acuerdo: '',
        vigencia: new Date(),
        responsable: null,
        montoMaximo: '',
        prioridad1: '',
        prioridad2: '',
        emailsAdicionalesNotificacion: []
    }
    const { proyectoPlan, setProyectoPlan, handleChangeProyecto } = useForm(datosIniciales);
    useEffect(() => {
        setCheckedInvestigacion(proyectoPlan.tipo === 'investigacion' ? true : false)
    }, [proyectoPlan])

    const verificarTipoProyectosPerfil = () => {
        let reglas = decoded.rules
        if (!reglas)
            reglas = obtenerReglas()
        /*Si tiene permiso para manejar proyectos de investigación
          el tipo por default en la forma será ese, de lo contrario
          será gestion*/
        if (!isEditing) {
            proyectoPlan.tipo = 'gestion'
            if (!reglas)
                return false
            for (let i = 0; i < reglas.length; i++) {

                if (reglas[i].action === 'manage' && reglas[i].subject === 'proyectoInvestigacion') {
                    proyectoPlan.tipo = 'investigacion'
                    //console.log('TIENE PERMISOS PARA PROYECTO DE INVESTIGACIÓN')
                    return true
                }
            }
            //console.log('NO TIENE PERMISOS PARA PROYECTO DE INVESTIGACIÓN')
            return false
        }
    }
    const [checkedInvestigacion, setCheckedInvestigacion] = useState(verificarTipoProyectosPerfil);

    const navigate = useNavigate()

    const verificarPrioridades = async (elemento, prioridadN, N, elemento2, M) => {
        const valor = elemento.value.replace(/,/g, '')
        const nombre = elemento.name
        const montoMaximo = isNaN(planPresupuestal.montoMaximo) ? planPresupuestal.montoMaximo.replace(/,/g, '') : planPresupuestal.montoMaximo

        setPlanPresupuestal({ ...planPresupuestal, [nombre]: valor, [prioridadN]: montoMaximo - valor })


        if (Number(valor) > Number(montoMaximo)) {
            setSeverity('error')
            setMensaje(`El monto  de la prioridad ${N} no puede superar al monto del plan `)
            setOpen(true)
            setMontoExcedido(true)
            elemento.style.color = 'red'
            return;
        }
        else {
            elemento.style.color = 'black'
            setMontoExcedido(false)
            setOpen(false)
        }
        const valor2 = montoMaximo - valor
        if (Number(valor2) > Number(montoMaximo)) {
            setSeverity('error')
            setMensaje(`El monto  de la prioridad ${M} no puede superar al monto del plan `)
            setOpen(true)
            setMontoExcedido(true)
            elemento2.style.color = 'red'
            return;
        }
        else {
            elemento2.style.color = 'black'
            setMontoExcedido(false)
            setOpen(false)
        }

    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        planPresupuestal.idResponsable = idResponsable
        //console.log(`monto plan ${planPresupuestal.montoMaximo}`)
        if (isNaN(planPresupuestal.montoMaximo)) {
            const monto = planPresupuestal.montoMaximo.replace(/,/g, '')
            planPresupuestal.montoMaximo = monto
        }

        //console.log(`monto plan ${planPresupuestal.montoMaximo}`)
        if (editing) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/ajustarMonto/${planPresupuestal.idPlanPresupuestal}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify(planPresupuestal)
            })
            const data = await res.json()
            //colocar un mensaje para orientar al usuario, se está validando desde sequelize
            if(res.status === 200)
                setSeverity('success')
            else
                setSeverity('error')
            if (data.message) {
                setOpen(true)
                setMensaje(data.message)
                setLoading(false)
                return
            }
            else {
                setOpen(true)
                setMensaje("Se ajustó el monto de la planeación")
            }

        }
        else {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/asignarMonto/${sessionStorage.getItem('idEntidad')}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify(planPresupuestal)
            })


            const data = await res.json()
            //colocar un mensaje para orientar al usuario, se está validando desde sequelize
            if(res.status === 200)
                setSeverity('success')
            else
                setSeverity('error')
            if (data.message) {
                setOpen(true)

                setMensaje(data.message)
                setLoading(false)
                return
            }
            else {
                setOpen(true)
                setMensaje("Se asignó un monto a una nueva planeación")
                navigate('/true')
            }
        }
        setLoading(false)
        navigate(0)
    }

    const handleConcluirRegistroPresupuestal = async () => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/concluirRegistroPresupuestal`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify({ id: planPresupuestal.idPlanPresupuestal, idRegistrante: idResponsable })
        })
        const data = await res.json()
        //colocar un mensaje para orientar al usuario, se está validando desde sequelize
        if(res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')
        if (data.message) {
            setOpen(true)

            if (data.message === 'Finalizó la asignación de presupuesto a los proyectos, se han enviado los emails para notificar el inicio de la elaboración de informes')
                setFase(1)

            setMensaje(data.message)
            setLoading(false)
            setPlanPresupuestal(data.planPresupuestal)
            return
        }
    }
    const handleAprobadaConsejo = async () => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/cambiarAprobadaConsejo/${planPresupuestal.idPlanPresupuestal}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const data = await res.json()
        //colocar un mensaje para orientar al usuario, se está validando desde sequelize
        if(res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')
        if (data.message) {
            setOpen(true)
            if (data.message === 'La planeación ha sido aprobada por el Consejo')
                setFase(3)
            setMensaje(data.message)
            setLoading(false)
            return
        }
    }

    const verificarPermisos = () => {
        let reglas = decoded.rules
        if (!reglas)
            reglas = obtenerReglas()

        if (!reglas)
            return false;
        for (let i = 0; i < reglas.length; i++) {

            if (reglas[i].action === 'manage' && reglas[i].subject === 'planPresupuestal') {
                //console.log('TIENE PERMISOS PARA PLAN PRESUPUESTAL')
                return true
            }
        }
        return false
    }
    const [isPermitido] = useState(verificarPermisos())

    useEffect(() => {
        (async () => {
            await cargarPlan()
        })();
        // eslint-disable-next-line
    }, [])
    return (
        <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }}>
            {/*planPresupuestal.fase===0?*/
                <Grid item xs={12}>
                    <Card>

                        <CardHeader title={fase < 3 ? (editing ? 'Editar Plan Presupuestal' : 'Agregar Nuevo Plan Presupuestal') : `Plan Presupuestal ${planPresupuestal.anio}`}></CardHeader>
                        <CardContent>
                            <Grid container justifyContent='space-between' spacing={5}>
                                <Grid item>
                                    <form onSubmit={handleSubmit}>
                                        {isPermitido ?
                                            <FormControl>
                                                <TextField name='montoMaximo' label="Monto máximo" onChange={(e) => {
                                                    // console.log(`dentro de onchange ${e.target.value} monto previo ${planPresupuestal.montoPrevio} `)
                                                    const valor = e.target.value
                                                    const nombre = e.target.name
                                                    const valorNumerico = Math.abs(valor.replace(/,/g, ''))
                                                    //console.log(`porcentajePrioridad1 ${porcentajePrioridad1}`)
                                                    // console.log(`porcentajePrioridad2 ${porcentajePrioridad2}`)
                                                    // console.log(`process.env.REACT_APP_PRIORIDAD_DOS ${process.env.REACT_APP_PRIORIDAD_DOS}`)
                                                    setPlanPresupuestal({ ...planPresupuestal, [nombre]: valor, 'prioridad1': Number(Number(valorNumerico) * Number(porcentajePrioridad1)).toFixed(2), 'prioridad2': Number(Number(valorNumerico) * Number(porcentajePrioridad2)).toFixed(2) })
                                                }} InputProps={{
                                                    inputComponent: NumberFormatMoney,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            $
                                                        </InputAdornment>
                                                    ),
                                                }} value={planPresupuestal.montoMaximo} />

                                                <TextField id="prioridad1Plan" name='prioridad1' label="Prioridad 1" onChange={(e) => {
                                                    verificarPrioridades(e.target, 'prioridad2', 1, document.getElementById('prioridad2Plan'), 2)

                                                }} InputProps={{
                                                    inputComponent: NumberFormatMoney,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            $
                                                        </InputAdornment>
                                                    ),
                                                }} value={Number(planPresupuestal.prioridad1 ? planPresupuestal.prioridad1 : 0).toFixed(2)} style={{ marginTop: 20 }} />
                                                <TextField id='prioridad2Plan' name='prioridad2' label="Prioridad 2" onChange={(e) => {
                                                    verificarPrioridades(e.target, 'prioridad1', 2, document.getElementById('prioridad1Plan'), 1)
                                                }} InputProps={{
                                                    inputComponent: NumberFormatMoney,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            $
                                                        </InputAdornment>
                                                    ),
                                                }} value={Number(planPresupuestal.prioridad2 ? planPresupuestal.prioridad2 : 0).toFixed(2)} style={{ marginTop: 20 }} />
                                                {fase < 3 && !editing ?
                                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={(!planPresupuestal.montoMaximo) || montoExcedido || loading}>
                                                        Asignar Monto
                                                    </Button> : <></>
                                                }
                                                {fase < 3 && editing && !isCoordinacion ?
                                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={(!planPresupuestal.montoMaximo) || montoExcedido || loading}>
                                                        Ajustar Monto
                                                    </Button> : <></>
                                                }
                                                {fase === 3 ?
                                                    <><br /><Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '100%' }} onClick={() => { window.open(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/mostrarReporteCierre/${planPresupuestal.idPlanPresupuestal}`) }}>Reporte Cierre Planeación <PictureAsPdfTwoToneIcon></PictureAsPdfTwoToneIcon></Button></> : <></>
                                                }
                                            </FormControl>
                                            :
                                            <>No tiene permisos para Planeación Presupuestal del Departamento, Coordinación o División</>
                                        }
                                    </form>
                                </Grid>
                                {fase < 3 ? (editing ? <>
                                    <Grid item>
                                        <FormControl>
                                            <TextField name='montoAsignado' label="Monto asignado" disabled InputProps={{
                                                inputComponent: NumberFormatMoney,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }} value={Number(planPresupuestal.montoAsignado).toFixed(2)} />

                                            <TextField name='prioridad1Asignada' label="Prioridad 1 asignada" disabled InputProps={{
                                                inputComponent: NumberFormatMoney,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }} value={Number(planPresupuestal.prioridad1Asignada).toFixed(2)} style={{ marginTop: 20 }} />
                                            <TextField name='prioridad2Asignada' label="Prioridad 2 asignada" disabled InputProps={{
                                                inputComponent: NumberFormatMoney,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }} value={Number(planPresupuestal.prioridad2Asignada).toFixed(2)} style={{ marginTop: 20 }} />

                                            {Number(planPresupuestal.montoDisponible) === Number(0) && fase === 0 ?
                                                <><br />
                                                    <Button variant='contained' type='button' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} onClick={handleConcluirRegistroPresupuestal}>
                                                        Concluir registro presupuestal
                                                    </Button>
                                                </> : <></>
                                            }
                                            {fase === 2 ?
                                                <><br />
                                                    <Button variant='contained' type='button' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} onClick={handleAprobadaConsejo}>
                                                        Aprobada por Consejo
                                                    </Button>
                                                </> : <></>
                                            }
                                        </FormControl>
                                    </Grid>
                                    <Grid item>
                                        <FormControl>
                                            <TextField name='montoDisponible' label="Monto disponible" disabled InputProps={{
                                                inputComponent: NumberFormatMoney,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }} value={Number(planPresupuestal.montoDisponible).toFixed(2)} />
                                            <TextField name='prioridad1Disponible' label="Prioridad 1 disponible" disabled InputProps={{
                                                inputComponent: NumberFormatMoney,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }} value={planPresupuestal.prioridad1Disponible} style={{ marginTop: 20 }} />

                                            <TextField name='prioridad2Disponible' label="Prioridad 2 disponible" disabled InputProps={{
                                                inputComponent: NumberFormatMoney,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }} value={planPresupuestal.prioridad2Disponible} style={{ marginTop: 20 }} />
                                        </FormControl>
                                    </Grid></> : <></>) : <></>}
                            </Grid>
                            <Box sx={{ width: '100%' }}>
                                <Collapse in={open}>
                                    <Alert severity={severity}
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small"
                                                onClick={() => {
                                                    setOpen(false);
                                                }}
                                            >
                                                <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                        }
                                        style={{ marginTop: 30 }}
                                    >
                                        {mensaje}
                                    </Alert>
                                </Collapse>
                            </Box>
                        </CardContent>

                    </Card>

                </Grid>
                /* :<></>*/
            }
            {planPresupuestal.idPlanPresupuestal === 0 ? <></> :
                fase < 3 || isEditing ?
                    <ProyectoPlanForma plan={planPresupuestal} planMontoDisponible={planPresupuestal.montoDisponible}
                        isEditing={isEditing} setIsEditing={setIsEditing} jefe={planPresupuestal.idResponsable} datosIniciales={datosIniciales}
                        proyectoPlan={proyectoPlan} setProyectoPlan={setProyectoPlan} handleChangeProyecto={handleChangeProyecto}
                        checkedInvestigacion={checkedInvestigacion} setCheckedInvestigacion={setCheckedInvestigacion} fase={fase} />
                    : <></>
            }

            {!planPresupuestal.proyectoPlans || (planPresupuestal.proyectoPlans && planPresupuestal.proyectoPlans.length < 1) ? <></> :
                <ProyectosPlanLista plan={planPresupuestal} setProyectoPlan={setProyectoPlan} setIsEditing={setIsEditing}
                    setPlanPresupuestal={setPlanPresupuestal} fase={fase} setFase={setFase} planeacion={planeacion} isCoordinacion={isCoordinacion} />
            }
        </Grid>
    )
}


